<template>
  <div class="w-full flex flex-wrap lg:flex-nowrap">
    <div
      class="w-full lg:w-2/12 flex items-center justify-center lg:justify-start"
    >
      <img
        v-if="settings.logo"
        class="flex items-center justify-center flex-shrink-0 w-full max-w-[12rem] mb-16"
        :src="settings.logo"
        :alt="settings.profile_title + 'logo'"
      />
    </div>
    <div class="flex-grow">
      <div class="flex flex-col w-full items-center justify-center">
        <FormulateForm
          :key="formKey"
          v-model="form"
          name="contactForm"
          class="w-3/4"
          @submit="sendForm"
        >
          <h3 class="font-semibold text-xl mb-4 text-center lg:text-left">
            Get in touch
          </h3>
          <p class="font-thin text-xs mb-4 text-center lg:text-left">
            Send a message directly to the advisor at
            {{ settings.profile_title }}
          </p>
          <div class="flex flex-col gap-4">
            <FormulateInput
              name="name"
              placeholder="Name"
              validation="required:trim"
              :input-class="['text-xs']"
            />
            <FormulateInput
              name="email"
              placeholder="Email"
              validation="bail|required:trim|email"
              :input-class="['text-xs']"
            />
            <FormulateInput
              name="comments"
              type="textarea"
              rows="2"
              placeholder="Comments"
              validation="required:trim"
              :input-class="['text-xs']"
            />
            <FormulateInput
              type="submit"
              :disabled="loading"
              :input-class="[
                'w-40 h-10 btn-primary ml-auto mr-auto lg:ml-0 lg:mr-0',
              ]"
            >
              <span
                v-if="loading"
                class="w-full h-6 flex items-center justify-center"
              >
                <lottie :options="loadingAnimationOptions" />
              </span>
              <span v-else> Submit </span>
            </FormulateInput>
          </div>
        </FormulateForm>
      </div>
    </div>
    <div v-if="contacts.length" class="flex-grow flex items-center mb-16">
      <div class="w-full lg:border-l-4 lg:pl-6 border-black mt-8 lg:mt-0">
        <h3 class="font-semibold text-center lg:text-left">
          Contact Information
        </h3>
        <div
          v-for="(contact, i) in contacts"
          :key="i"
          :class="i < contacts.length - 1 ? 'mb-4' : ''"
        >
          <p class="font-semibold text-center lg:text-left">
            {{ contact.name }}
          </p>
          <p
            v-if="contact.job_title"
            class="font-thin text-xs text-center lg:text-left"
          >
            {{ contact.job_title }}
          </p>
          <p class="font-thin text-xs text-center lg:text-left">
            <span class="font-semibold">Email: </span>{{ contact.email }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useStore } from '../../../../../../js/store/index.js'
import * as loadingAnimation from '../../../../../../shared/components/loading.json'

export default defineComponent({
  name: 'Layout2ContactForm',
  components: {},
  props: {},

  setup() {
    const store = useStore()
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const loading = ref(false)

    const settings = computed(() => store.getters['shared/getSettings'])
    const client = computed(() => store.getters['shared/getClient'])

    const form = ref({
      name: '',
      email: '',
      comments: '',
    })

    // Used to re-render the form after it has been successfully resolved in sending
    // Vue formulate doesn't SEEM to support reset methods while using the composition API
    const formKey = ref(0)
    const contacts = computed(() => store.getters['shared/getAdminsPublic'])

    const sendForm = async (payload) => {
      loading.value = true
      payload.client = client.value
      payload.tenant = settings.value.contact_email
      const response = await store.dispatch(
        'careerwise/dispatchContactFormEmail',
        payload,
      )
      if (response) {
        form.value = {
          name: null,
          email: null,
          comments: null,
        }
        formKey.value++
      }
      loading.value = false
    }
    onMounted(() => {})

    return {
      loadingAnimationOptions,
      loading,
      settings,
      contacts,
      form,
      formKey,
      sendForm,
    }
  },
})
</script>
